import PageLayout from 'pages/InstructorFormativeJourney/PageLayout';
import PageProvider from 'pages/InstructorFormativeJourney/PageProvider';

const InstructorFormativeJourneyPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorFormativeJourneyPage;
